<template>
	<div ref="frcWidget" class="frc-captcha"></div>
</template>

<script>
import { WidgetInstance } from "friendly-challenge";

export default {
	name: 'friendly-captcha',
	props: {
		sitekey: {
            type: String,
            required: true,
        },
	},
	mounted: function() {
		if (!this.frcWidget) {
            this.frcWidget = new WidgetInstance(this.$refs.frcWidget, {
                sitekey: this.sitekey,
                language: 'de',
                doneCallback: this.onDone.bind(this),
                errorCallback: this.onError.bind(this),
                puzzleEndpoint: "https://eu-api.friendlycaptcha.eu/api/v1/puzzle"
            });
        }
	},
	destroyed() {
        if (this.frcWidget) {
            this.frcWidget.destroy();
        }
    },
	data: function() {
		return {
			frcWidget: null
		}
	},
	methods: {
		onDone: function(solution) {
			this.$emit('done', solution);
		},
		onError: function(error) {
			this.$emit('error', error);
		}
	}
}
</script>



// WEBPACK FOOTER //
// FriendlyCaptcha.vue?3f6e1712